// 鼠币商城相关页面api
import Http from "./http";

const apiPath = {
  // 1、 鼠币商城banner接口_获取数据列表
  banner: "/xhr-cms/mouse-shop-banner/page",
  // 1、 鼠币商城查询全部鼠币商品
  query_all: "/xhr-cms/mouse-money-product/query-all",
  // 1、 鼠币商城查询新的鼠币商品
  query_new: "/xhr-cms/mouse-money-product/query-new",
  // 1、 鼠币商城查询订单列表
  order: "/xhr-cms/mouse-money-order/query",
  // 1、 鼠币商城查询收货地址
  address: "/xhr-cms/shopping-address/page",
  // 个人中心  鼠币详情
  getMouse: "/xhr-cms/mouse-coin-detail/getPage",

  // 个人中心  新增鼠币订单
  orderAdd: "/xhr-cms/mouse-money-order/add",
  // 个人中心  鼠币
  getMouseCoin: "/xhr-cms/mouse-coin-detail/getMouseCoin",
  //   鼠币商城 确认收货
  confirm: "/xhr-cms/mouse-money-order/confirm"
};

/**
 * @desc 所有请求方法请写在 loginApi 变量内
 * @desc 每个方法前请备注用途
 * @param {Object} params 请求参数
 */

const mouseApi = {
  //  鼠币商城查询全部鼠币商品
  getProduct(params) {
    return Http.post(apiPath.query_all, params);
  },
  //  鼠币商城查询全部鼠币商品
  getProductNew(params) {
    return Http.post(apiPath.query_new, params);
  },
  //  鼠币商城查询订单列表
  getOrder(params) {
    return Http.post(apiPath.order, params);
  },
  //  鼠币商城查询地址
  getAddress(params) {
    return Http.post(apiPath.address, params);
  },
  // 个人中心 鼠币详情
  getMouse(params) {
    return Http.post(apiPath.getMouse, params);
  },

  // 个人中心 新增速比订单
  orderAdd(params) {
    return Http.post(apiPath.orderAdd, params);
  },

  // 个人中心 新增速比订单
  getMouseCoin(params) {
    return Http.post(apiPath.getMouseCoin, params);
  },
  // 鼠币商城 获取banner
  banner(params) {
    return Http.post(apiPath.banner, params);
  },

  // 鼠币商城 获取banner
  confirm(params) {
    return Http.post(apiPath.confirm, params);
  }
};

export default mouseApi;



// WEBPACK FOOTER //
// ./src/api/mouse.js